import React, {useState} from "react";
import SideBarFilter from "../SideBarFilter/SideBarFilter";
import CheckBox from "../CheckBox/CheckBox";
import ExploreCardsSection from "../ExploreCardsSection/ExploreCardsSection";

const FullCardAndFilterSection = () => {
  const [sideBarFilter, setSideBarFilter] = useState({
    tier1: true,
    tier2: false,
    drip: true,
    br34p: false,
    acq: false,
    eth: true,
    arb: false,
  });

  return (
    <div className="max-w-[1920px]  mx-auto">
      <div className="flex items-start flex-col gap-[30px] md:flex-row">
        <div className=" w-full md:w-[330px]  rounded-r-[20px] bg-main-black">
          <SideBarFilter setSideBarFilter={setSideBarFilter}></SideBarFilter>
        </div>
        <div className="px-[20px]  md:pl-0 grow xl:pr-[49px]">
          <ExploreCardsSection
            sideBarFilter={sideBarFilter}
          ></ExploreCardsSection>
        </div>
      </div>
    </div>
  );
};

export default FullCardAndFilterSection;
